import { render, staticRenderFns } from "./3dContent.vue?vue&type=template&id=74c9576e&scoped=true&"
import script from "./3dContent.vue?vue&type=script&lang=js&"
export * from "./3dContent.vue?vue&type=script&lang=js&"
import style0 from "./3dContent.vue?vue&type=style&index=0&id=74c9576e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c9576e",
  null
  
)

export default component.exports